module.exports = __webpack_public_path__ + "img/watch_time_pocketwatch_white.ffb7b445.jpg";